import { Component, Input, OnInit } from '@angular/core';
import { SearchTableViewModel } from '../../../view-models/search-table.view-model';

@Component({
  selector: 'app-search-table-footer',
  templateUrl: './search-table-footer.component.html',
  styleUrls: ['./search-table-footer.component.scss'],
  standalone: false,
})
export class SearchTableFooterComponent implements OnInit {
  @Input()
  public nextPageText: string;

  @Input()
  public previousPageText: string;
  public pages: number[];

  constructor() {
  }

  private _searchTableViewModel: SearchTableViewModel<any>;

  get searchTableViewModel(): SearchTableViewModel<any> {
    return this._searchTableViewModel;
  }

  @Input() set searchTableViewModel(value: SearchTableViewModel<any>) {
    this._searchTableViewModel = value;

    this.refresh();
  }

  ngOnInit(): void {
    this.refresh();
  }

  setPage(page: number) {
    this.searchTableViewModel.currentPage = page;

    this.refresh();
  }

  nextPage() {
    if (this.hasNextPage()) {
      this.searchTableViewModel.currentPage++;

      this.refresh();
    }
  }

  previousPage() {
    if (this.searchTableViewModel.currentPage > 1) {
      this.searchTableViewModel.currentPage--;

      this.refresh();
    }
  }

  getPages(): number[] {
    const numberOfPages = Math.max(1, Math.ceil(this.searchTableViewModel.numberOfTotalResults / this.searchTableViewModel.numberOfResultsPerPage));

    const pages = [];
    for (let i = 1; i <= numberOfPages; i++) {
      pages.push(i);
    }

    return pages;
  }

  hasNextPage(): boolean {
    return (this.searchTableViewModel.numberOfTotalResults - (this.searchTableViewModel.numberOfResultsPerPage * this.searchTableViewModel.currentPage)) > 0;
  }

  refresh() {
    this.searchTableViewModel.modelUpdated();
  }
}
